import { render, staticRenderFns } from "./campaign-email-modal.vue?vue&type=template&id=24fe1caf&scoped=true&"
import script from "./campaign-email-modal.vue?vue&type=script&lang=js&"
export * from "./campaign-email-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fe1caf",
  null
  
)

export default component.exports